var map = {
	"./ANTV.png": "07a6",
	"./Astrapay.png": "93ec",
	"./BRI.png": "2951",
	"./BTPN.png": "bf8c",
	"./Bankjatim.png": "660a",
	"./Best.png": "d67a",
	"./Binus.png": "fa21",
	"./Blibli.png": "0827",
	"./DANA.png": "d245",
	"./Elmo.png": "3dca",
	"./Elnusa.png": "4995",
	"./Garuda.png": "d1bb",
	"./Gojek.png": "e656",
	"./Gotoko-Logo.png": "7e2b",
	"./Indosat.png": "6a8a",
	"./Kemenkes.png": "74f5",
	"./Lakuemas.png": "d5c4",
	"./Manulife.png": "10dc",
	"./Nexsoft.png": "c931",
	"./PP.png": "40b7",
	"./Prakerja-Logo.png": "d577",
	"./Sicepat.png": "8080",
	"./Smartfren.png": "474d",
	"./Telkom.png": "8981",
	"./Travymeal.png": "6a08",
	"./Voy.png": "0845",
	"./XL.png": "3c06",
	"./accelerice.png": "2f5b",
	"./danacita.png": "54e4",
	"./facebook.png": "04a3",
	"./instagram.png": "3637",
	"./linkedin.png": "537d",
	"./logo-mitra.png": "83c4",
	"./pintek.png": "2189",
	"./redhat-logo.png": "d227",
	"./twitter.png": "7411",
	"./youtube.png": "e244"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2c7";